import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'

export function useInboxConfiguration() {
  const {configuration} = useQuery({
    query: gql`
      query getCurrentInboxConfiguration {
        configuration: getCurrentInboxConfiguration {
          configurationId: _id
          balancerEnabled
          onlyAcceptsChatsWithActiveOrder
        }
      }
    `,
    pollInterval: 10000
  })

  return {configuration}
}

export function useAgents() {
  const {agents} = useQuery({
    query: gql`
      query getAgents {
        agents: supervisors {
          _id
          fullName
          activeForAutoAssignChat
          roles
          inboxPreference {
            _id
            countryCodes
            maxChats
          }
        }
      }
    `,
    pollInterval: 10000
  })

  return {agents}
}
